import { createFileRoute } from '@tanstack/react-router';
import CelExpressionEditor from '@/common/components/cel/CelExpressionEditor.tsx';
import { attributeCelContextSchema } from '@pac/cel';
import { Paper, Stack } from '@mantine/core';

export const Route = createFileRoute('/test')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Stack>
      <Paper withBorder>
        <CelExpressionEditor
          language="plainTextHandlebars"
          mode={'singleLine'}
          contextSchema={attributeCelContextSchema}
          value={''}
          onChange={(value) => console.log(value)}
        />
      </Paper>
      <Paper withBorder>
        <CelExpressionEditor
          mode={'singleLine'}
          contextSchema={attributeCelContextSchema}
          value={''}
          onChange={(value) => console.log(value)}
        />
      </Paper>
    </Stack>
  );
}
